import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "spinner--sprite",
  "use": "spinner--sprite-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" id=\"spinner--sprite\">\n  <circle cx=\"50\" cy=\"50\" fill=\"none\" stroke-width=\"8\" r=\"35\" stroke-dasharray=\"164.93361431346415 56.97787143782138\" transform=\"rotate(352.4 50 50)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol